import React from 'react';
import styled from 'styled-components';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import SectionHeader from 'components/text/SectionHeader';

const FlexCenterCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

class AdminHeader extends React.PureComponent {
  render() {
    return (
      <Row>
        <FlexCenterCol xs={20}>
          <SectionHeader>{this.props.header}</SectionHeader>
        </FlexCenterCol>
        <FlexCenterCol xs={4}>{this.props.action}</FlexCenterCol>
      </Row>
    );
  }
}

export default AdminHeader;



// WEBPACK FOOTER //
// ./src/components/common/AdminHeader/index.js